import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'app/services/auth.service';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { SpinnerService } from 'app/services/spinner.service';
import { RegisterService } from 'app/services/user/register.service';
import { UserService } from 'app/services/user/user.service';

@Component({
  selector: 'ms-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  private currentUrl: string;

  userMessage: string = '';

  constructor(private auth: AuthService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private registerService: RegisterService,
    private modalService: NgbModal,
    private spinnerService: SpinnerService,
    private userService: UserService,
    private commonUtilService : CommonUtilService) {

    this.currentUrl = this.activatedRouter.snapshot.queryParams.ticket;
  }
  ngOnInit() {
    this.spinnerService.start();
    this.getToken();
  }

  getToken() {
    this.currentUrl = this.activatedRouter.snapshot.queryParams.ticket;

    if (this.currentUrl) {
      this.auth.login(this.currentUrl);

      if (this.auth.isLoggedIn) {

        this.userService.adminCheck().subscribe(dataAdmin => {

          if (dataAdmin != null) {

            if (dataAdmin) {

              this.auth.setVerified(true);
              this.auth.setAdminUser(true);

              this.router.navigate(['/home']);

            } else {
              this.registerService.getCompletionResultForRegisterUser().subscribe(data => {
                /* console.log(data); */
                if (data) {
                  this.auth.setVerified(data.completedEmailVerification);
                  this.auth.setAdminUser(data.adminUser);
                  if (!data.completedEmailVerification) {
                    this.userMessage = "Registered user email not verified";
                  } else if(data.hrweUserStatus === 'DA_ATTIVARE') {
                    this.userMessage = "your profile is under approval process, so the login will be denied";
                  } else if(data.hrweUserStatus === 'DISABILITATO'){
                    this.userMessage = "Your profile has been disabled, so the login will be denied";
                  } else if(data.hrweUserStatus === 'RIFIUTATO'){
                    this.userMessage = "Your profile has been refused, so the login will be denied";
                  } else {
                    this.router.navigate(['/home']);
                  }
                  if(this.userMessage !== ''){
                    this.auth.logout();
                    let modalElem = <HTMLInputElement>document.querySelector("#launchModal");
                    modalElem.click();
                  }
                }
              });
            }
          }
        });
      }
    } else {
      window.location.href = "/sso";
    }
  }

  open(content) {
    this.modalService.open(content).result.then((result) => {

      this.commonUtilService.logout();
    }, (reason) => {
      if (reason) {
        this.commonUtilService.logout();
      }
    });
  }

}
